import { ApolloClient, InMemoryCache } from '@apollo/client';

/**
 * See here for implementation in TS
 * https://bitbucket.org/mvfglobal/abbey-customers-frontend/src/master/src/Global/Gateway/Apollo.ts
 */

// Private function to create the client - not exported
const createApolloClient = () => {
  return new ApolloClient({
    uri: `${process.env.NEXT_PUBLIC_CHAMELEON_GATEWAY_BASE_URL}/graphql`,
    cache: new InMemoryCache({ addTypename: false }),
  });
};

// The singleton instance is created once when this module is imported
export const client = createApolloClient();

// Helper functions that use the singleton client for non-React code (e.g. sagas)
export const query = (options) => client.query(options);
export const mutate = (options) => client.mutate(options);

// For React components, import and use 'client' directly with ApolloProvider
